import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../App';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Package, Send, Activity } from 'lucide-react';
import { toast } from 'sonner';

export default function Dashboard({ user }) {
  const [stats, setStats] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/dashboard/stats')
      .then(res => setStats(res.data))
      .catch(err => toast.error('Failed to load stats'));
  }, []);

  if (!stats) return <div className="text-white text-center">Loading...</div>;

  return (
    <div className="space-y-6" data-testid="dashboard">
      <h1 className="text-4xl font-bold text-white" style={{fontFamily: 'Space Grotesk'}}>Dashboard</h1>
      
      <div className="grid md:grid-cols-3 gap-6">
        <Card className="glass-card cursor-pointer hover:shadow-xl transition-shadow" onClick={() => navigate('/batches')} data-testid="batches-stat-card">
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium">File Batches</CardTitle>
            <Package className="h-4 w-4 text-blue-600" />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold">{stats.total_batches}</div>
          </CardContent>
        </Card>

        <Card className="glass-card cursor-pointer hover:shadow-xl transition-shadow" onClick={() => navigate('/send-batches')} data-testid="send-batches-stat-card">
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium">Send Batches</CardTitle>
            <Send className="h-4 w-4 text-purple-600" />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold">{stats.total_send_batches}</div>
          </CardContent>
        </Card>

        <Card className="glass-card" data-testid="activity-stat-card">
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium">Recent Activity</CardTitle>
            <Activity className="h-4 w-4 text-green-600" />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold">{stats.recent_sends?.length || 0}</div>
          </CardContent>
        </Card>
      </div>

      {stats.recent_sends && stats.recent_sends.length > 0 && (
        <Card className="glass-card">
          <CardHeader>
            <CardTitle>Recent Send Batches</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-2">
              {stats.recent_sends.map(send => (
                <div key={send.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100" onClick={() => navigate(`/send-batches/${send.id}`)} data-testid={`recent-send-${send.id}`}>
                  <div>
                    <div className="font-medium">{send.subject || 'No subject'}</div>
                    <div className="text-sm text-gray-500">{new Date(send.created_at).toLocaleDateString()}</div>
                  </div>
                  <div className={`status-badge status-${send.status}`}>{send.status}</div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
